import { useField } from "formik";
import DateOnlyInput from "./DateOnlyInput";

export default function FormikDateOnlyInput({ name, label }) {
  const [field, meta, helpers] = useField(name);

  return (
    <div>
      <DateOnlyInput
        name={name}
        label={label}
        value={field.value}
        onChange={(value) => {
          helpers.setValue(value);
          helpers.setTouched(true);
        }}
      />
      {meta.touched && meta.error && (
        <p className="my-4 text-sm text-red-500 dark:text-red-400">{meta.error}</p>
      )}
    </div>
  );
}
